module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Breakpoints</h1>\n    </header>\n\n    <div class="tabs">\n        <span class="tab active">Responsive Breakpoints</span>\n    </div>\n    <div class="tab-pane active">\n        <div class="row">\n            <div class="col-xs-4">\n                <p class="intro">With Creator\'s Breakpoint Settings you can set up the Breakpoints that correspond with your website.</p>\n                <p>The Breakpoints will define intervals to which you can assign different Breakpoint Variants in the Editor.</p>\n\n                <div class="notification-box">\n                    <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Changes to Breakpoint Settings</span>\n                    <p>Changes to your Breakpoint Settings will not affect existing Breakpoint Groups. To modify these, open "Assign Breakpoint Variants" in the Editor and accept the new Breakpoint Settings.</p>\n                </div>\n            </div>\n\n            <div class="col-xs-8">\n                <ul class="breakpoints-flex-section list-unstyled">\n                ';
 _.each(naming, function(name, index){ ;
__p += '\n                    <li class="breakpoint-flex-item">\n                        <div class="interval-indicator ' +
__e( name ) +
'">' +
__e( name ) +
'</div>\n\n                    ';
 if (index > 0) { ;
__p += '\n                        <button class="delete-breakpoint" data-index="' +
__e( index - 1 ) +
'" ' +
__e( (permissionToManage && naming.length > 2) ? "" : "disabled" ) +
'></button>\n                        <label class="breakpoint-value" data-unit="px">\n                            <input class="breakpoint-input" type="number" min="1" step="1" value="' +
__e( breakpoints.at(index - 1).get('threshold') ) +
'" data-index="' +
__e( index - 1 ) +
'" ' +
__e( permissionToManage || "disabled" ) +
'>\n                        </label>\n                    ';
 } ;
__p += '\n                    </li>\n                ';
 }); ;
__p += '\n                    <li class="add-breakpoint">\n                        ';
 if(permissionToManage && naming.length < 6) { ;
__p += '\n                        <button class="add btn btn-secondary">\n                            &#43; Add ';
 if(naming.length < 4) { ;
__p += '\n                                Breakpoint\n                            ';
 } ;
__p += '\n                        </button>\n                        ';
 } ;
__p += '\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/breakpoint/BreakpointSettingsView.tpl
// module id = 2834
// module chunks = 0